import { APIKeys } from "../../components/APIKeys";
import { AuthenticatedLayout } from "../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const APIKeysPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="API Keys"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Api Keys', navigateTo: '/me/api'}]}
      mainContents={<APIKeys testId="api-keys-setup-page" />}
    />
  );
};
